import React from 'react';
import emailImg from '../../../images/Email-img';
import emailjs from 'emailjs-com';

const ContactForm = () => {
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('gmail', 'template_q5cj24c', e.target, 'user_RvpX7xfyMDPnLuQ2WI4ZC')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
        e.target.reset();
    }

    return (
        <div className="container contactForm-area pt-5 my-5">
            <h3 className="Title mt-5">Contact</h3>

            <h4 className="sub-title mb-5 p3-4">Contact With me</h4>
            <div className="row mt-4">
                <div className="col-md-6 ">
                    <img className="img-fluid" src={emailImg} alt=""/>
                </div>

                <div className="col-md-6">
                    <form className="contact-form" onSubmit={sendEmail}>
                        <div className="d-flex mb-3">
                            <input type="text" className="form-control mr-1" name="name" placeholder="Name*" />
                            <input type="email" className="form-control ml-1" name="email" placeholder="Email*" />
                        </div>
                        <input type="text" className="form-control mb-3" name="subject" placeholder="Subject*" />
                        <textarea className="form-control mb-3" name="message" placeholder="Message*" cols="30" rows="5"></textarea>
                        <input type="submit" value="Send Message" className="btn custom-btn" />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;